<div class="disclaimer" [ngClass]="classes" [innerHtml]="disclaimer | safeHtml"></div>
